export function convertToCSV(arr: any[]) {
  const titleKeys = Object.keys(arr[0]).map((x) => x.charAt(0).toUpperCase() + x.slice(1));

  const refinedData = [];
  refinedData.push(titleKeys);

  arr.forEach((item) => {
    refinedData.push(Object.values(item));
  });

  return refinedData.map((row) => `${row.join(';')}\n`).join('');
}

export function arrayUpdateIndex(arr: any[]) {
  let index = 0;
  return arr.map((item) => {
    const temp = { ...item, index };
    index += 1;
    return temp;
  });
}

export function arrayMove(arr: any[], oldIndex: number, newIndex: number) {
  const temp = arr[oldIndex];
  let i;

  for (i = oldIndex; i >= newIndex; i -= 1) {
    arr[i] = arr[i - 1];
  }

  arr[newIndex] = temp;
  return arr;
}

export function uniqueEntry(value: any, index: number, self: any[]) {
  return self.indexOf(value) === index;
}
